/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./bit.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./bit.component";
var styles_BitComponent = [i0.styles];
var RenderType_BitComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_BitComponent, data: {} });
export { RenderType_BitComponent as RenderType_BitComponent };
export function View_BitComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_BitComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "fl-bit", [], null, null, null, View_BitComponent_0, RenderType_BitComponent)), i1.ɵdid(1, 49152, null, 0, i2.BitComponent, [], null, null)], null, null); }
var BitComponentNgFactory = i1.ɵccf("fl-bit", i2.BitComponent, View_BitComponent_Host_0, {}, {}, ["*"]);
export { BitComponentNgFactory as BitComponentNgFactory };
